import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private http: HttpClient) { }

  getUsuarios(page: number, size: number, activo: number, search?:string): Observable<any>{

      let url = `/api/users?page=${page}&size=${size}`;
    if(search) {
      url = url + `&buscar=${search}`;
      
    } 
    return this.http.get<any>(environment.baseUrl +`${url}`);
  }
  
  nuevoUsuario(username: string, password: string, email: string, last_name: string, name: string, dni: number, cell_phone: number, roleId:number, activo: number, legajo?: number): Observable<any>{
    let url = `/api/users`;
    let body = {
      username,
      password,
      email,
      last_name,
      name,
      dni,
      cell_phone,
      roleId,
      activo,
      empleg: legajo
    }
    
    return this.http.post<any>(environment.baseUrl +`${url}`,body);
  }

  deleteUsuario(id:number){
    let url = `/api/users/${id}`;

    return this.http.delete<any>(environment.baseUrl +`${url}`);
  }

  updateUsuario(id:number, body: any){
    let url = `/api/users/${id}`

    return this.http.put<any>(environment.baseUrl +`${url}`, body);
  }

  updatePassword(id:number, password: any){
    let url = `/api/users/password/${id}`
    let body ={
      password
    }

    return this.http.put<any>(environment.baseUrl +`${url}`, body);
  }


  public recoverPassword(email: string){
    return this.http.post(environment.baseUrl +`/api/users/recoverPass`, {'email': email})
  }

  public resetPassword (email:string, clave:string){
    return this.http.post(environment.baseUrl +`/api/users/resetPass`, {'email': email, 'clave': clave})
  }

  public verificarUser(token){
    return this.http.post(environment.baseUrl +`/api/users/userByEmail`, {'token':token})
  }
}
